import React from "react";
import PpeAlertSettings from "../../components/admin/PpeAlertSettings";
import BranchSettings from "../../components/admin/BranchSettings";
import TeamSettings from "../../components/admin/TeamSettings";

function normalizeRole(roleCode) {
  return String(roleCode || "USER").trim().toUpperCase();
}

// 시스템 전역 설정 모음 (관리자 전용)
// - PPE(안전장구) 알림 ON/OFF
// - 지점 관리 (슈퍼어드민 전용)
// ※ 녹화 보존기간은 민감 항목이라 대시보드에서 제외 — PC 설치 시 프로그램에서 설정.
export default function AdminSystemPage({ me }) {
  const amISuperAdmin = normalizeRole(me?.roleCode) === "SUPER_ADMIN";

  return (
    <div className="h-full min-h-0 overflow-y-auto pr-1">
      <div className="space-y-4">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white">시스템 설정</h2>

        {/* 슈퍼어드민: PPE 알림 + 지점 관리 2단 / 그 외: PPE 알림 전체 폭 */}
        <div
          className={`grid grid-cols-1 gap-4 lg:items-start ${
            amISuperAdmin ? "lg:grid-cols-2" : ""
          }`}
        >
          {/* 안전장구(PPE) 알림 ON/OFF — 서버 전역 설정 */}
          <PpeAlertSettings />

          {/* 지점 관리 — 슈퍼어드민 전용 */}
          {amISuperAdmin && <BranchSettings />}

          {/* 팀 관리 — 슈퍼어드민 전용. 지점이 있어야 팀을 만들 수 있어 지점 관리 옆에 둔다. */}
          {amISuperAdmin && <TeamSettings />}
        </div>
      </div>
    </div>
  );
}
